let breakpointHelper = null;
let currentBreakpoint = () => '';

if (!IS_SSR) {
  currentBreakpoint = () => {
    breakpointHelper = document.getElementById('breakpoint-helper');

    if (!breakpointHelper) {
      return '';
    }

    // eslint-disable-next-line no-useless-escape
    return window.getComputedStyle(breakpointHelper, ':before').content.replace(/\"/g, '');
  };
}

export default currentBreakpoint;
